function resolveSizes(size) {
    var _a;
    if (typeof size === "string") {
        return { baseSize: size };
    }
    return {
        baseSize: (_a = size.xs) !== null && _a !== void 0 ? _a : "md",
        smSize: size.sm,
        mdSize: size.md,
        lgSize: size.lg,
    };
}

export { resolveSizes };
